module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "seo"
  }, [_c('seo-title', {
    attrs: {
      "content": "Volkswagen Klub København - Din volkswagen familie"
    }
  }), _vm._v(" "), _c('seo-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen ErhvervsCenter København og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-author', {
    attrs: {
      "content": "Deveo ApS"
    }
  }), _vm._v(" "), _c('seo-keywords', {
    attrs: {
      "content": "VW, VW København, VW Erhvervscenter, VW Erhvervsbiler, Volkswagen"
    }
  }), _vm._v(" "), _c('seo-og-title', {
    attrs: {
      "content": "Volkswagen Klubbens netværksmøde - Skal du med?"
    }
  }), _vm._v(" "), _c('seo-og-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen ErhvervsCenter København og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-og-site-name', {
    attrs: {
      "content": "VW København Erhvervscenter"
    }
  }), _vm._v(" "), _c('seo-google-name', {
    attrs: {
      "content": "Volkswagen Klubbens netværksmøde - Skal du med?"
    }
  }), _vm._v(" "), _c('seo-google-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen ErhvervsCenter København og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-google-image', {
    attrs: {
      "content": ""
    }
  })], 1), _vm._v(" "), _c('intro', {
    attrs: {
      "videoId": "7bGJbhDr7TM",
      "bg": "/static/images/focus-1.jpg",
      "buttonText": "DATO KOMMER SNART"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            VOLKSWAGEN KØBENHAVN"), _c('br'), _vm._v("ERHVERVSKLUB\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "subtitle"
    },
    slot: "subtitle"
  }, [_vm._v("\n            Deltag i Volkswagen ErhvervsCenter Københavns netværksmøde og udvid dit netværk på en uformel måde.\n        ")])]), _vm._v(" "), _c('boxes', {
    attrs: {
      "intro": "Volkswagen ErhvervsCenter Københavns netværksmøde",
      "firstText": "God stemning & nye bekendtskaber",
      "firstPicture": "/static/images/focus-1.jpg",
      "secondText": "Minvolkswagen: Din vej til flådestyring",
      "secondPicture": "/static/images/focus-2.jpg",
      "thirdText": "Innovativ bilindretning",
      "thirdPicture": "/static/images/focus-3.jpg"
    }
  }), _vm._v(" "), _c('practical-info', {
    attrs: {
      "title": "Dette skal du glæde dig til"
    }
  }, [_c('div', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n            For at give vores kunder ny inspiration og et forum for networking, holder vi for danske håndværkere jævnligt netværksmøder. Her er der mulighed for deltagerne, vores oplægsholdere og os at indgå i tæt dialog og videndele om udfordringer, ny teknologi og de muligheder, der byder sig i fremtiden.\n            "), _c('br'), _c('br'), _vm._v("\n            Hvert møde har et fagligt fokus, hvor vi får besøg af en ekspert på området. Det kan være finansiering, forsikring, håndværktøj, revision, markedsføring og mange flere. Hold øje med, hvad du kan opleve ved det møde, du ønsker at deltage i.\n            "), _c('br'), _c('br'), _vm._v("\n            Vi starter tidligt om morgenen, så det ikke går ud over din arbejdstid. Der serveres morgenmad og en velsmagende kop friskbrygget kaffe. Vi glæder os til at se dig.\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "address"
    },
    slot: "address"
  }, [_vm._v("\n            Volkswagen København"), _c('br'), _vm._v("\n            Banevingen 9"), _c('br'), _vm._v("\n            2200 København N\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "datetime"
    },
    slot: "datetime"
  }, [_vm._v("\n            Dato kommer snart\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "partners"
    },
    slot: "partners"
  }, [_c('a', {
    attrs: {
      "href": "https://deveo.dk/",
      "target": "_blank",
      "rel": "noopener nofollow"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/deveo-logo.png",
      "width": "120"
    }
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "href": "https://www.volkswagen.dk/da/ny-volkswagen/samlede-losninger.html",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "vw-bold"
    }
  }, [_vm._v("Volkswagen")]), _vm._v(" Finans\n            ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.volkswagen.dk/da/ny-volkswagen/samlede-losninger.html",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "vw-bold"
    }
  }, [_vm._v("Volkswagen")]), _vm._v(" Forsikring\n            ")])])]), _vm._v(" "), _c('promo', {
    attrs: {
      "title": "Transporter",
      "staticCarId": "1",
      "buttonLink": "https://www.volkswagen-erhvervsbiler.dk/da/modeller/transporter-kassevogn.html#",
      "buttonText": "Online showroom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n            Transporter med sikkerheds- eller infotainmentpakke uden merpris.\n        ")])]), _vm._v(" "), _c('statement-and-price', {
    attrs: {
      "title": "Gå herfra inspireret og med nye bekendtskaber",
      "price": "GRATIS",
      "mainEmployeeImage": "/static/images/mg.jpg",
      "mainEmployeeName": "Martin Gill",
      "mainEmployeeTitle": "Salgschef, Volkswagen ErhvervsCenter København",
      "secondaryEmployeeImage": "/static/images/rv.jpg",
      "secondaryEmployeeName": "Runi Villebæk",
      "secondaryEmployeeTitle": "Salgsrådgiver, Volkswagen ErhvervsCenter København"
    }
  }, [_c('div', {
    attrs: {
      "slot": "statement"
    },
    slot: "statement"
  }, [_vm._v("\n            Deltag i vores uformelle netværksmøde, hvor du både bliver inspireret af nye løsninger indenfor teknologi, leasing og meget mere, samtidig med at vi sammen kan løse de problemstillinger du måtte have i din dagligdag.\n            "), _c('br'), _c('br'), _vm._v("\n            Bilverdenen er i konstant forandring og i årene fremover vil der derfor blive stillet større krav til driftsomkostningerne/TCO af virksomhedens flåde. Du vil få større budgetsikkerhed samt højne kvaliteten af din investering.\n            "), _c('br'), _c('br'), _vm._v("\n            Om din flåde består af 1 eller 100 biler, står vi altid klar med professionel rådgivning.\n            "), _c('br'), _c('br'), _vm._v("\n            Vi glæder os til at byde dig velkommen i Volkswagen familien.\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "check-mark",
    attrs: {
      "slot": "benefits"
    },
    slot: "benefits"
  }, [_vm._v("Adgang til arrangement")]), _vm._v(" "), _c('li', {
    staticClass: "check-mark",
    attrs: {
      "slot": "benefits"
    },
    slot: "benefits"
  }, [_vm._v("Mad & drikke")]), _vm._v(" "), _c('li', {
    staticClass: "check-mark",
    attrs: {
      "slot": "benefits"
    },
    slot: "benefits"
  }, [_vm._v("Networking")])]), _vm._v(" "), _c('registration', {
    attrs: {
      "eventId": "ddb054affa69ce60f11597144",
      "eventToken": "4243223ffc",
      "disabled": true,
      "name": "Koebenhavn"
    }
  }), _vm._v(" "), _c('contact', {
    attrs: {
      "title": "Volkswagen ErhvervsCenter København",
      "phone": "+45 43 22 30 12",
      "facebookUrl": "VolkswagenCopenhagen"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-407d0474"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/retailers/koebenhavn/14062018/index.vue
// module id = 238
// module chunks = 1